import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="account.password-confirmation-label" defaultMessage="Confirm password" />
);
